<template>
    <div class="pb-5">
        <div class="row no-gutters px-md-0 px-2">
            <div class="col-md-10 offset-md-1 box px-md-4 pt-md-3 mt-md-5 mt-4  border-line" style="border-radius:10px">
                <div class="row no-gutters main-window mt-md-3" style="border-radius: 13px;position: relative;">
                    <div class="col-12">
                        <div class="window-header p-1 rounded">
                            <i class="material-icons text-pink ml-2 top-botttom-aling">circle</i>
                            <i class="material-icons text-warning ml-2 top-botttom-aling">circle</i>
                            <i class="material-icons text-danger ml-2 top-botttom-aling">circle</i>
                            <div class="float-right search-bottom mt-2 ml-1 mr-1">
                                <span class="material-icons ml-2 text-info" style="font-size:20px">search</span>
                            </div>
                            <div class="float-right search mt-2">
                                <span class="material-icons ml-2 text-warning" style="font-size:20px">star_border</span>
                                <span class="material-icons ml-2 text-warning" style="font-size:20px">star_border</span>
                                <span class="material-icons ml-2 text-warning" style="font-size:20px">star_border</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 pl-4 pr-4 pt-4">
                        <h5 class="text-pink">Github Repositories /&gt;</h5>
                        <div class="block-one mt-2"></div>
                        <div class="shine-hr"></div>
                    </div>
                    <div v-if="getRepos.length > 1" class='text-pink px-3 mt-3'>
                        <span style="font-size: 13px;">&nbsp; Public Repositories</span>
                        <button style="font-size: 13px;" class="btn badge  ml-1 btn-sm pt-0 pb-0 ">{{
                            getRepos.length
                        }}</button>
                        <div class="hide_pc"></div>
                        <span style="font-size: 13px;" class="ml-md-4 ml-2 mt-1">Showing Repositories</span>
                        <button style="font-size: 13px;" class="btn badge ml-1 btn-sm pt-0 pb-0 ">{{
                            getRepos.length - 1
                        }}</button>
                    </div>
                    <div class="col-12" v-if="getGithubApiErrStatus">
                        <LoadingFail redirect='githubapi' />
                    </div>
                    <div v-else-if="getGithubApiPendingStatus" class="col-12 mt-5">
                        <Pending />
                    </div>
                    <div class="col-12 row no-gutters pb-5 px-4 ">
                        <div class="card-columns">
                            <div v-for="repo in getRepos" :key="repo.id" id="mouseMoveAni" data-value="1">
                                <div v-if="repo.name != 'mine' && repo.name != 'me'">
                                    <div class="card rounded mt-2 bg-dark ">
                                        <div class="card-header p-1 bg-dark border-0 ">
                                            <h6 class="card-title pl-3 pt-2">
                                                <a :href="repo.html_url" style="text-decoration: none;font-size: 13px;"
                                                    class="text-pink">
                                                    {{ repo.name }}
                                                </a>
                                            </h6>
                                        </div>
                                        <div class="card-footer border-0">
                                            <div class="card-text">
                                                <small class="text-pink text-info" style="font-size: 10px;">{{ repo.language
                                                }}</small>
                                                <a href="https://github.com/ShineShineDev" class="text-pink">
                                                    <img src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/refs/heads/main/imgs/me.jpg" class="profile-img float-right"
                                                        alt="">
                                                    <small class="float-right mr-2 icons-aling text-info"
                                                        style="font-size: 10px;">{{
                                                            repo.owner.login }}</small>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 pt-3 pb-5">
                        <img src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/refs/heads/main/imgs/mongodb.png" class="mongodb-logo" />
                        <RocketAnimation />
                    </div>
                </div>
                <div class="text-center">
                    <span class="material-icons text-warning text-center mt-2 rotate">lens</span>
                </div>
            </div>
            <div class="col-4 offset-4 pl-md-5 pr-md-5">
                <div class="computer-foot box ml-md-5 mr-md-5"></div>
            </div>
            <div class="col-8 col-md-4 offset-md-4 computer-foot2 offset-2 box"></div>
            <div class="col-md-1">
                <img src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/55f9002887e4a0cbb513502045b1734b2f2fbe67/imgs/mysql.svg" class="mysql-img mt-2" />
            </div>
        </div>
    </div>
</template>

<script>
import LoadingFail from "./../components/LoadingFail.vue";
import Pending from "./../components/Pending.vue";
import RocketAnimation from "./../components/RocketAnimation.vue";
import {InitBrowserAgent} from "./../services/detech-visitors.js";

export default {
    name: 'Repositories',
    components: {
        Pending, LoadingFail,RocketAnimation
    },
    data() {
		return {
			host: process.env.VUE_APP_HOST,
		};
	},
    created() {
        const {browser,language,platform,innerWidth,innerHeight,URL,visitor_generated__id,is_new_visitor,outerWidth,outerHeight,referrer} = InitBrowserAgent(); 
        this.$store.dispatch('initApi', { url: 'https://bot.okjapanstore.com/api/tg/notify', method: 'POST', data: { Noti: 'Alert',URL,browser,language,platform,innerWidth,innerHeight,visitor_generated__id , is_new_visitor,innerWidth,innerHeight,outerWidth,outerHeight,referrer} });
        this.$store.dispatch('initGithubApi');
    },
    computed: {
        getGithubApiErrStatus() {
            return this.$store.getters.getGithubApiErrStatus;
        },
        getGithubApiPendingStatus() {
            return this.$store.getters.getGithubApiPendingStatus;
        },
        getRepos() {
            return this.$store.getters.getRepos;
        },
    },
}
</script>

<style scoped>
.profile-img {
    width: 30px;
    height: 30px;
    border-radius: 100%;
}

.pub-repo {
    border-radius: 50%;
    widows: 10px;
    height: 20px;
}

.jquery-img {
    transform: rotate(20deg);
    width: 45px;
    position: relative;
    left: 80%;
}
.shine-hr {
  margin-top: 5px;
  margin-bottom: 4px;
  border: 0px;
  height: 2px;
  background:rgb(65, 62, 62);
}

@import url('https://fonts.googleapis.com/css2?family=Silkscreen:wght@400;700&display=swap');

.silkscreen-regular {
    font-family: "Silkscreen", sans-serif;
    font-weight: 400;
    font-style: normal;
}
.text-pink {
    color: pink;
}
.border-line {
    border-radius: 50%;
    border-left: 2px solid #FF4A01;
    border-right: 2px solid #FF4A01;
    border-radius: 0 0 10px 10px;
}
.custom-bg-color {
    background-color: #ff4a01;
}

@keyframes shineAnimation {
    0% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0 50%;
    }
}

.main-window {
    background: rgba(0, 0, 0, 0.2);
    border: 2px solid rgba(255, 217, 217, 0.2);
}

.window-header {
    background: rgba(255, 255, 255, 0.4);
    border-top: 2px solid rgba(255, 217, 217, 0.2);
    border-bottom: 2px solid rgba(255, 217, 217, 0.2);
}

.window-header>.search {
    background: rgba(0, 0, 0, 0.2);
    width: 40%;
    height: 20px;
    border-radius: 10px;
}

.code-line-one {
    background: rgba(0, 0, 0, 0.1);
    width: 60%;
    height: 6px;
    border-radius: 5px;
    opacity: 0.1;
}

.code-line-two {
    background: rgba(0, 0, 0, 0.1);
    width: 46%;
    height: 6px;
    border-radius: 5px;
    opacity: 0.1;
}

.code-line-four {
    background: rgba(0, 0, 0, 0.1);
    width: 41%;
    height: 6px;
    border-radius: 5px;
    opacity: 0.1;
}

.code-line-three {
    background: rgba(0, 0, 0, 0.1);
    width: 74%;
    height: 6px;
    border-radius: 5px;
    opacity: 0.1;
}

.code-line-five {
    background: rgba(0, 0, 0, 0.1);
    width: 30%;
    height: 6px;
    border-radius: 5px;
    opacity: 0.1;
}

.search-bottom {
    background: rgba(0, 0, 0, 0.2);
    width: 30px;
    height: 20px;
    border-radius: 10px;
}

.computer-foot {
    background: rgba(255, 255, 255, 0.4);
    height: 100px;
}

.computer-foot2 {
    height: 30px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
}

.laravel-logo {
    transform: rotate(20deg);
    width: 50px;
    position: relative;
    left: 24%;
}

.mongodb-logo {
    transform: rotate(20deg);
    width: 70px;
    position: relative;
    top: -20px;
    left: 24%;
}

.mysql-img {
    transform: rotate(20deg);
    width: 30px;
    position: relative;
    left: 84%;
}
</style>
